import React from 'react';

const AccentedText = ({ children }) => (
  <span className="integrationsPortal-accentedText">{children}</span>
);

export default AccentedText;
